export enum EHiddenNameFields {
  NAMING_STANDARDS_FORBIDDEN = '_namingStandardsForbidden',
  HAS_EXACT_MATCH = '_hasExactMatch',
  EXACT_MATCH_ALLOW = '_exactMatchAllow',
  IS_EXACT_MATCH_ARE_IGNORED = '_isExactMatchAreIgnored'
}
